<div class="watch-report-modal">
  <div class="header">
    @if (commentReport) {
      <h2 translate>watch.report_modal.title_comment</h2>
    }
    @if (videoReport) {
      <h2 translate>watch.report_modal.title_video</h2>
    }
    @if (workoutReport) {
      <h2 translate>watch.report_modal.title_workout</h2>
    }
  </div>
  <div class="content">
    <!-- SELECT -->
    <div class="reason-select-menu">
      <p translate>watch.report_modal.reason_report</p>
      <kin-dropdown [options]="commentReportReasons"></kin-dropdown>
    </div>
  </div>

  <div class="footer">
    @if (commentReport) {
      <kin-btn
        color="primary"
        (onClick)="sendCommentReport()"
        [disabled]="isReported">
        {{ 'watch.report_modal.title_comment' | translate }}
      </kin-btn>
    }

    @if (videoReport) {
      <kin-btn
        color="primary"
        (onClick)="sendVideoReport()"
        [disabled]="isReported">
        {{ 'watch.report_modal.title_video' | translate }}
      </kin-btn>
    }

    @if (workoutReport) {
      <kin-btn
        color="primary"
        (onClick)="sendWorkoutReport()"
        [disabled]="isReported">
        {{ 'watch.report_modal.title_workout' | translate }}
      </kin-btn>
    }

    <kin-btn (onClick)="closeReportModal()">
      {{ 'watch.commun.cancel' | translate }}
    </kin-btn>
  </div>
</div>
